module.exports = __webpack_public_path__ + "static/img/img_guide3.c0658f70.png";